import { FilterButton } from '@/shared/components/FilterButton/FilterButton'
import {
  FilterButtonModel,
  MobileFilterButtons,
} from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'

type Props = {
  filterButtons: FilterButtonModel[]
  selectedBtn: number
  setSelectedBtn: (index: number) => void
  minWidthMobile?: string
  maxWidthMobile?: string
  className?: string
}

export const AdaptiveFilterButtons = ({
  filterButtons,
  selectedBtn,
  setSelectedBtn,
  maxWidthMobile,
  minWidthMobile,
  className,
}: Props) => {
  const isMobile = useIsMobile()
  return (
    <div className={`w-full ${className || ''}`}>
      {isMobile ? (
        <MobileFilterButtons
          selectedIndex={selectedBtn}
          setSelectedIndex={setSelectedBtn}
          filterButtons={filterButtons}
          maxWidth={maxWidthMobile}
          minWidth={minWidthMobile}
        />
      ) : (
        <div className="flex flex-wrap gap-0.5">
          {filterButtons?.map((b) => (
            <FilterButton
              key={b.index}
              name={b.name}
              onClick={() => setSelectedBtn(b.index)}
              selected={b.index === selectedBtn}
            />
          ))}
        </div>
      )}
    </div>
  )
}
